/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationView {
    getFixupPrototypeFunction() { return RecommendationView.fixupPrototype; }

    static newInstance(model: Partial<RecommendationView>): RecommendationView {
        let obj = Object.assign(new RecommendationView(), model);
        RecommendationView.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationView>): RecommendationView {
        if (!model) return null;
        return RecommendationView.newInstance(<RecommendationView> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationView) {
        if (!obj) return;

        models.RecommendationView.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationView): boolean {
        Object.setPrototypeOf(obj, RecommendationView.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.estimated_cost === undefined) {
            this.estimated_cost = 0;
        }
        if (this.estimated_cost_saving === undefined) {
            this.estimated_cost_saving = 0;
        }
    }

    /**
     * Identifier for resource recommendation
     */
    resource_recommendation_id: string;

    /**
     * Recommendation id
     */
    recommendation_id: string;

    /**
     * Resource name
     */
    resource_name: string;

    /**
     * Resource type
     */
    resource_type: string;

    /**
     * Resource id
     */
    resource_id: string;

    /**
     * Status
     */
    status: string;

    /**
     * Summary
     */
    summary: string;

    /**
     * Impact level
     */
    impact_level: string;

    /**
     * Estimated cost
     */
    estimated_cost: number;

    /**
     * Region
     */
    region: string;

    /**
     * Estimated cost saving
     */
    estimated_cost_saving: number;

    /**
     * Optimization type
     */
    optimization_type: string;

    /**
     * Recommended SKU
     */
    recommended_sku: string;

    /**
     * Current SKU
     */
    current_sku: string;

    /**
     * Savings percentage
     */
    savings_percentage: string;

    /**
     * Estimated cost saving information
     */
    estimated_cost_saving_info: string;

}
